import { AuthEnums } from "models/enums";
import { ApiClientInstance } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

/**
 * @deprecated This service is deprecated. Use useSettingsService hook instead.
 *
 * @see useSettingsService - The replacement hook
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const SettingsService = {
  getProfileSettings: () => {
    return ApiClientInstance(AuthEnums.AuthType.User, {
      showErrors: true,
    })
      .SettingsClient.ProfileSettings()
      .then((res) => res.data);
  },
  updateProfileSettings: (profileSettings: WintSuperkollAPIModel.ProfileSettingsPut) => {
    return ApiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).SettingsClient.UpdateProfileSettings(profileSettings);
  },
};

export default SettingsService;
